module.exports = __webpack_public_path__ + "img/安徽阳光就业网.e59e01a7.jpg";